import { ia } from 'lib/helpers/utility';

export const achOptions = (savedACHs) => [
  {
    label: 'Saved ACH',
    value: 'saved-ach',
    disabled: !ia(savedACHs),
    tooltip: !ia(savedACHs) && "You don't have any saved ACH"
  },
  { label: 'New ACH', value: 'new-ach' }
];
